import { useTranslation } from "@/packages/utils";

export function AudineroIcon({ size = 24 }: { size?: number }) {
  const { t } = useTranslation(["common"]);
  return (
    <svg
      width={size}
      height={size}
      viewBox="63 63 226 226"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={t("ui.chatPanel.audinero")}
    >
      <path
        d="M124.4 174.3H73.6V123.8c0-28 22.7-50.8 50.8-50.8H175v50.6c0 28-22.7 50.7-50.6 50.7z"
        fill="currentColor"
      />
      <path
        d="M229.6 176.5h1.5c28.1 0 50.9-22.8 50.9-50.9v-1.5c0-28.1-22.8-50.9-50.9-50.9H178.6v52.3c0 28.1 22.8 51 51 51z"
        fill="currentColor"
      />
      <path
        d="M229.2 279.4h-50.6v-50.6c0-28 22.7-50.8 50.8-50.8H280v50.6c0 28-22.7 50.8-50.8 50.8z"
        fill="currentColor"
      />
      <path
        d="M122.9 281.3h1.5c28.1 0 50.9-22.8 50.9-50.9v-1.5c0-28.1-22.8-50.8-50.9-50.8H72v52.3c0 28.1 22.8 50.9 50.9 50.9z"
        fill="currentColor"
      />
    </svg>
  );
}
